import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RenderView from "./Collections/RenderCollection";

function App() {
  return (
    <Router>
      <Routes>
        {/* <Route path="/" element={<>{"Home"}</>} /> */}
        <Route path="/:id" element={<RenderView />} />
        <Route path="*" element={<>{"Not Found"}</>} />
      </Routes>
    </Router>
  );
}

export default App;
